"use client";

import Link from "next/link";

import { Button } from "@workspace/ui/components/button";
import { EventNames, SectionTypes, sendEvent, withSectionType } from "@/lib/utils/analytics";

export function CommunityCta({ id }: { id: string }) {
  return (
    <Button
      id={id}
      data-testid={id}
      size="lg"
      className="lg:px-[50px] lg:py-[15px] lg:rounded-[14px]"
      asChild
    >
      <Link
        href="/buy-now"
        onClick={() =>
          sendEvent(
            EventNames.JOIN_COMMUNITY_CLICKED,
            withSectionType(SectionTypes.COMMUNITY_SECTION),
          )
        }
      >
        Join now
      </Link>
    </Button>
  );
}
